module.exports = __webpack_public_path__ + "static/media/29_tn.691d7621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/29_tn.jpg
// module id = 167
// module chunks = 0